import {createSlice} from '@reduxjs/toolkit';
//types
import {IUserRaffleReduser} from '../../utils/types';

export const initialState: IUserRaffleReduser = {
	ticketTiers: [],
	isLoading: false,
};

const userRaffleStore = createSlice({
	name: 'userRaffle',
	initialState,
	reducers: {
		setLoading(state, {payload}) {
			state.isLoading = payload;
		},
		setRaffleTickets(state, {payload}) {
			state.ticketTiers = payload;
		},

		setInitialRaffleTickets(state, {payload}) {
			state.ticketTiers = payload;
			state.isLoading = false;
		},
	},
});

export const {setRaffleTickets, setInitialRaffleTickets, setLoading} = userRaffleStore.actions;
export default userRaffleStore.reducer;
